import React from 'react';
import { Modal, Result, Typography, Input, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { FrameAction } from '../../redux/slice/frame/root_main_slice';

const { TextArea } = Input
const { Paragraph, Text } = Typography;

const WithInfoMsgModal = (props:any) => {
    const dispatch = useAppDispatch();
    const isOpenPopup = useAppSelector((state) => state.Frame.isOpenPopup);

    const close = (data:any) => {
        if (props.accept && typeof props.accept === 'function') {
            props.accept(data);
        }
    }

    const getPopupModal = () => {
        let Contents = props.contents;
        const _props = {...props.props, accept:close};
        return <Contents {..._props}/>
    }

    const handleOk = (_e: React.MouseEvent<HTMLElement>) => {
        dispatch(FrameAction.setIsOpenPopup(false));
        if (props && props.accept && typeof props.accept === 'function') {
            props.accept();
        }
    };
  
    const handleCancel = (_e: React.MouseEvent<HTMLElement>) => {
        dispatch(FrameAction.setIsOpenPopup(false));
        if (props && props.cancel && typeof props.cancel === 'function') {
            props.cancel();
        }
    };

    React.useEffect(() => {
        if (props.isOpenPopup) {
            dispatch(FrameAction.setIsOpenPopup(props.isOpenPopup));
        }
    }, []);

    const alertResult = React.useCallback(() => {
        return (
            <Result
                key='resultCloseAlert'
                status='success'
                title={<TextArea value={typeof props.contents === 'string' ? props.contents.replace(/<br\/>/gi, '\n') : props.contents} bordered={false} autoSize={true} style={{textAlign:'center'}}/>}
                extra={[
                    <Button key='btnCloseAlert' id='closeAlert' type='primary' onClick={handleOk}>확인</Button>
                ]}
            >
            </Result>
        )
    }, [props]);

    const infoResult = React.useCallback(() => {
        return (
            <Result
                key='resultInfoAlter'
                icon={<ExclamationCircleOutlined style={{ color: '#108ee9' }} />}
                title={<TextArea value={typeof props.contents === 'string' ? props.contents.replace(/<br\/>/gi, '\n') : props.contents} bordered={false} autoSize={true} style={{textAlign:'center'}}/>}
                extra={[
                    <Button key='btnCloseInfoAlert' id='closeInfoAlert' type='primary' onClick={handleOk}>확인</Button>
                ]}
            />
        )
    }, [props]);

    const confirmResult = React.useCallback(() => {
        return (
            <Result
                key='confirm'
                icon={<ExclamationCircleOutlined style={{ color: '#108ee9' }}/>}
                title={<TextArea value={typeof props.contents === 'string' ? props.contents.replace(/<br\/>/gi, '\n') : props.contents} bordered={false} autoSize={true} style={{textAlign:'center'}}/>}
                extra={[
                    <Button key='btnCloseAlert'  id='acceptAlert' type='default' onClick={handleCancel}>취소</Button>,
                    <Button key='btnAcceptAlert' id='cancelAlert' type='primary' onClick={handleOk}>확인</Button>
                ]}
            >
            </Result>
        )
    }, [props]);


    const errorResult = React.useCallback(() => {
        return (
            <Result
                key='resultErrorAlter'
                status='error'
                title='요청하신 작업이 실패했습니다.'
                extra={[<Button key='btnCloseErrorAlert' id='closeErrAlert' type='primary' onClick={handleOk}>확인</Button>]}
            >
                <div className='desc'>
                    <Paragraph>
                        <Text strong style={{fontSize: 13}}>
                            아래와 같은 오류가 발생하였습니다.
                        </Text>
                    </Paragraph>
                    <TextArea rows={10} value = {typeof props.contents === 'string' ? props.contents.replace(/<br\/>/gi, '\n') : props.contents}>
                    </TextArea>
                </div>
            </Result>
        )
    }, [props]);

	return (
      <>
          <Modal
              zIndex={9998}
              footer={null}
              width=''
              styles={{
                body:{
                    height: 'auto',
                    width : 'auto',
                }
              }}
              centered
              closable={false}
              title={
                <div style={{ width: '100%'}}>
                  {props && props.title ? <p>{props.title}</p> : <p>타이틀</p>}
                </div>
              }
              open={isOpenPopup}
              maskClosable={false}
              onCancel={handleCancel}
            >
              {props && props.type === 'alert' ? alertResult() : props.type === 'info' ? infoResult() : props.type === 'confirm' ? confirmResult() : props.type === 'error' ? errorResult() : props.contents }
          </Modal>
      </>
	);
}

export default WithInfoMsgModal;
